const setLocalStorageScope= (value)=>{
    localStorage.setItem("scope",JSON.stringify(value))
}

const setXRequestSource= (value)=>{
    localStorage.setItem("x_request_source",value);
}

const handleScopes= (scope,x_request_source)=>{
    if(scope){
        if(Array.isArray(scope)){
            if(scope.length==0){
                if(x_request_source=="SELF"){
                    setLocalStorageScope(["*"])
                }
                else{
                    localStorage.setItem("shop_domain",true);
                }
            }
            else{
                if(scope.includes("*")){
                    setLocalStorageScope(["*"]);
                }
                else{
                    setLocalStorageScope(scope);
                }
            }
        }
        else{
            setLocalStorageScope(["*"]);
        }
    }
    else{
        if(x_request_source=="SELF"){
            setLocalStorageScope(["*"])
        }
        else{
            localStorage.setItem("shop_domain",true);
        }
    }
}

export const handleScopeAddition= (x_request_source, scope)=>{
    if(x_request_source){
        setXRequestSource(x_request_source);
        if(x_request_source=="SHOPIFY-APP" || x_request_source=="SELF"){
            handleScopes(scope, x_request_source);
        }
        else{
            setLocalStorageScope(["*"]);
        }
    }
    else{
        setLocalStorageScope(["*"])
    }
}

